import { z } from 'zod/v3';
import { TenantedRoleSchema, UntenantedRoleSchema } from './ability';

export const UserSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  email: z.string(),
  untenantedRoles: UntenantedRoleSchema.array(),
});

const OrgSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  workosId: z.string().nullable(),
});

const OrgRoleSchema = z.object({
  role: TenantedRoleSchema,
  userId: z.string(),
  orgId: z.string(),
});

const WhoamiSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  email: z.string(),

  /**
   * true when the user has no orgs and needs to complete onboarding.
   * null indicates onboarding is complete.
   */
  onboardingIncomplete: z.boolean().nullable(),

  impersonator: UserSchema.omit({ untenantedRoles: true }).nullable(),
  orgs: OrgSchema.array(),
  tenantedRoles: OrgRoleSchema.pick({ orgId: true, role: true }).array(),
  untenantedRoles: UntenantedRoleSchema.array(),
  pylonVerificationHash: z.string().nullable(),
});

export type Whoami = z.infer<typeof WhoamiSchema>;
export type Org = z.infer<typeof OrgSchema>;
export type OrgRole = z.infer<typeof OrgRoleSchema>;
